import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import { MenuItem, Select, FormControl, SelectChangeEvent } from '@mui/material';
import { changeUserStatus } from '@containers/Admin/containers/StaffPage/actions';
import { SELECTOR_WIDTH, USER_STATUS_OPTIONS } from './consts';
import { UserStatus } from './types';

interface SelectStatusProps {
  // TODO: Temporary prop - disabling the dropdown is a workaround until staff and user tables are unified.
  // Ideal: render status as read-only text (same as mentor view) once the refactor is done.
  canChangeStatus?: boolean;
}

export const SelectStatus = ({ canChangeStatus = true }: SelectStatusProps) => {
  const dispatch = useDispatch();
  const {
    userData: { id, state: status },
  } = useSelector((state: RootStateOrAny) => state.get('staffPage').toJS()); // FIXME replace to typing store

  const sendUserStatus = (event: SelectChangeEvent<UserStatus>): void => {
    dispatch(changeUserStatus(event.target.value, id));
  };

  const currentStatusHelper = (): UserStatus | undefined =>
    USER_STATUS_OPTIONS.find(({ value }: UserStatus) => value === status);

  return (
    <div>
      {status && (
        <FormControl sx={{ width: SELECTOR_WIDTH }} size="small">
          <Select
            value={currentStatusHelper()}
            onChange={sendUserStatus}
            renderValue={() => currentStatusHelper()?.label}
            disabled={!canChangeStatus}
          >
            {USER_STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </div>
  );
};
